import { Fragment, useState, useContext, useEffect, useRef } from 'react'
import { useModal } from '@leroy-merlin-br/backyard-react-ui'

import Glyph from 'reactGarden/Glyph'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import { LocationForm } from './index'
import { setRegionNameRef } from './Hooks'

const LocationInfo = () => {
  const context = useContext(HeaderContext)
  const { userResources } = context

  const pathname = window.location.pathname
  const [isModalVisible, setModalVisibility] = useState(false)
  const [isContextualized, setUserContext] = useState(false)

  const refRegionName = useRef(null)

  const { setModal } = useModal()

  useEffect(() => {
    if (pathname === '/localizacao' && !isModalVisible) {
      openRegionSelect()
    }
    setRegionNameRef(refRegionName)
  })

  useEffect(() => {
    isModalVisible && setModal({
      appElement: 'body',
      hasScroll: false,
      size: 'mega',
      onClose: () => setModalVisibility(false),
      children: ({ onClose }) => (
        <LocationForm
          showCloseButton={isContextualized}
          onClose={onClose}
        />
      )
    })
  }, [isContextualized, isModalVisible, setModal])

  const handleClick = () => {
    openRegionSelect()
    setUserContext(true)
  }

  const openRegionSelect = () => {
    setModalVisibility(true)
  }

  const checkLocation = () => {
    const { region, selectedRegionName } = userResources

    if (region) {
      return (
        <Fragment>
          <Glyph glyph="location" />
          { selectedRegionName }
        </Fragment>
      )
    }

    return 'Onde você está?'
  }

  return (
    <Fragment>
      <span className="color-primary location-info" onClick={handleClick} ref={refRegionName}>
        { checkLocation() }
      </span>
    </Fragment>
  )
}

export default LocationInfo
